import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { searchNewReviews, updateReview } from '../../../api/sportaloka-client';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function Reviews() {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit
      }).toString();
      const response = await searchNewReviews(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const showMessage = (message) => {
    Swal.fire({
      html: `<p class="text-left mt-20">${message}</p>`,
      showCloseButton: true,
      showConfirmButton: false
    });
  };

  const handleUpdate = async (id) => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Aksi ini tidak dapat dikembalikan',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Tetap lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setData([]);
          await updateReview(id);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Status berhasil diubah`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ width: '15%' }}>Penulis</th>
            <th className="text-left" style={{ width: '15%' }}>
              Tanggal Dibuat
            </th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data && data.length === 0 && !error && (
            <tr>
              <th className="text-center text-light-1" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data &&
            data.map((row) => (
              <tr key={row.id}>
                <td>{row.user.fullname}</td>
                <td className="text-left">
                  {format(new Date(row.created_at), 'dd/MM/yyyy HH:mm')}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default Reviews;
